const maketingAddCoupon = () =>
  import('@/views/main/marketing/coupon/add/add.vue')
export default {
  path: '/main/coupon/maketingAdd',
  name: 'maketingAddCoupon',
  component: maketingAddCoupon,
  children: []
}
